import React from 'react';
import { Box, styled} from '@mui/material';
import TopFooterItemMenu from './TopFooterItemMenu';
import { FOOTER } from '../../../../utils/constans/footerMenu';
import { FooterTitle } from '../../../styled/Footer/FooterTitle';
import { FooterItemContentStyle } from 'components/styled/Footer/FooterItemContentStyle';
import { useTranslation } from 'react-i18next';

const StyledBox = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    padding: '6px 3.175%',
    margin: '0 -15px',
    '> *': {
        flex: 1,
        paddingLeft: '15px',
        paddingRight: '15px',
    },
    [theme.breakpoints.down('md')]: {
        flexWrap: 'wrap',
        '> *': {
            flex: '0 0 33%',
        },
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },

}));

const LogoWrapper = styled(Box)(({ theme }) => ({
    img: {
        maxWidth: '250px',
    },
}));

const TopFooter = () => {

    const { t } = useTranslation();

    return (
        <StyledBox>
            {FOOTER.map((item) => (
                <TopFooterItemMenu
                    key={item.id}
                    title={item.title}
                    collectionHandle={item.menuHandle}
                />
            ))}
            <Box>
                <FooterTitle>{t('FOOTER.PARTNERS')}</FooterTitle>
                <FooterItemContentStyle>
                    <LogoWrapper>
                        <img src="/assets/posta_logo_200x.avif" />
                    </LogoWrapper>
                </FooterItemContentStyle>
            </Box>
            <Box>
                <FooterTitle>{t('FOOTER.AWARDS')}</FooterTitle>
                <FooterItemContentStyle>
                    {t('FOOTER.AWARD_NAME')}
                </FooterItemContentStyle>
            </Box>
            <Box>
                <FooterItemContentStyle>
                    <LogoWrapper>
                        <img src="/assets/MESTER_SZERELVENYOLT_logo_RGB.svg" />
                    </LogoWrapper>
                </FooterItemContentStyle>
            </Box>
        </StyledBox>
    );
};

export default TopFooter;
